import React from "react";
import { Avatar } from "@mui/material";
import Stack from "components/common/Stack";
import Text from "components/common/Text";
import InfoIcon from "@mui/icons-material/Info";
import TooltipHover from "components/common/TooltipHover";
import JarvisCard from "components/JarvisCard";

const DashboardDataCard = ({
  icon = "",
  value = "0",
  loading = false,
  color = "#1D9BFF",
  label = "-",
  gainLoss = "",
  sx = {},
  hasInfoIcon = false,
  onClick = null,
}) => {
  return (
    <JarvisCard
      sx={{
        borderRadius: "20px",
        p: 2,
        cursor: onClick ? "pointer" : "default",
        "&:hover": onClick ? { boxShadow: "0 4px 18px rgba(0,0,0,0.12)" } : {},
        ...sx,
      }}
      onClick={onClick}
    >
      {/* Horizontal Layout */}
      <Stack direction="row" alignItems="center" spacing={2}>
        {/* LEFT ICON */}
        <Avatar
          src={icon}
          sx={{
            width: 48,
            height: 48,
            backgroundColor: "#F5F7FA",
            padding: "10px",
            borderRadius: "14px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
          }}
        />

        {/* RIGHT TEXT */}
        <Stack spacing={0.5}>
          {/* VALUE */}
          <Text
            variant="subtitle2"
            color={color}
            sx={{ fontSize: "20px", fontWeight: 700 }}
          >
            {loading ? "Loading..." : value}
          </Text>

          {/* LABEL + INFO ICON */}
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <Text sx={{ color: "#808591", fontSize: "14px" }}>{label}</Text>

            {hasInfoIcon && (
              <TooltipHover title="Gains/loss exclude brokerage, taxes & fees.">
                <InfoIcon sx={{ width: 18, height: 18, color: "#a1a1a1" }} />
              </TooltipHover>
            )}
          </Stack>
        </Stack>
      </Stack>
    </JarvisCard>
  );
};

export default DashboardDataCard;
